import React from 'react';

export const useRedirectToMessagesHook = (props) => {
  const { isMessagingOnly, location, history, enableFeeds } = props;
  const shouldRedirect = isMessagingOnly && (location.pathname !== '/messages' && location.pathname !== '/feeds');
  const redirectRoute = enableFeeds ? '/feeds' : '/messages';
  React.useEffect(() => {
    if (shouldRedirect) {
      history.push(redirectRoute);
    }
  }, [shouldRedirect, history, redirectRoute]);

};
